import 'javascripts/new_form_validation'
